<template>
  <div>
    <div
      class="right"
      v-if="PERMISIONS.create && assignmentDocument.numberOfReferences == 0"
      style="padding-right: 1.75rem; padding-bottom: 5px"
    >
      <div @click="addProduct" class="Button1 Btn_center">
        <div class="icon">
          <img
            @load="imgLoaded"
            src="../../assets/media/for_table/circle_ADD_new_etap.svg"
            alt=""
          />
        </div>
        <span class="Btn_content"> Adaugă produs </span>
      </div>
    </div>
    <template v-if="PERMISIONS.list">
      <table-parent
        style="padding: 0; box-shadow: none; border-radius: 0px"
        :reloadCount="reloadTable"
        :tableHead="tableHead"
        :prepareFn="prepareData"
        :apiModule="tableModule"
        apiModuleName="ASSIGNMENT_PRODUCTS"
        :tableMinimizeHead="true"
        :tableSpread="true"
        @Btn2="editProduct"
        @Btn3="deleteProduct"
        @totalRecords="(x) => (totalRecords = x)"
      />
    </template>
    <template v-else>
      <h3 style="display: flex; flex-direction: column; align-items: center">
        <span style="font-size: 4rem">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Acces interzis
      </h3>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../../mixins/assignmentProductsPermMixin.js";
import updateRoleStatus from "../../mixins/updateUserRoleStatus.js";
import { ASSIGNMENT_PRODUCTS } from "../../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import EditAssignmentProduct from "@/components/assignment-products/EditAssignmentProduct";
import { Messages } from "../../common/messages.js";

export default {
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  props: {
    assignmentDocument: { type: Object, required: true },
  },
  data() {
    return {
      tableHead: [
        {
          title: "Produs",
          queryKey: "product.name",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare unitară",
          queryKey: "unitValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cotă TVA",
          queryKey: "tvaValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cantitate",
          queryKey: "quantity",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, fără TVA",
          queryKey: "totalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, cu TVA",
          queryKey: "totalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          spacer: true,
          minimize: 1,
          fixed: {
            right: true,
          },
          queryKey: "status",
          bottomHead: {
            quikFiltre: "assignmentProductStatus",
          },
        },
      ],
      tableModule: (x, y) =>
        ASSIGNMENT_PRODUCTS.get(
          x,
          y,
          `eq=assignmentDocumentId,${this.assignmentDocument.id}`,
        ),
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  computed: {
    notAllowEdit() {
      return (
        this.assignmentDocument.status == "approved" ||
        this.assignmentDocument.status == "waiting_approve" ||
        this.assignmentDocument.status == "signing_failed" ||
        this.assignmentDocument.status == "closed"
      );
    },
  },
  methods: {
    reload() {
      this.reloadTable++;
    },
    prepareData(row) {
      const preparation = [
        row.product.name || "-",
        this.prepareLocaleNumber(row.unitValue) || "-",
        this.prepareLocaleNumber(row.tvaValue) || "-",
        this.prepareLocaleNumber(row.quantity) || "-",
        this.prepareLocaleNumber(row.totalValueWithoutTva) || "-",
        this.prepareLocaleNumber(row.totalValueWithTva) || "-",
        {
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Draft",
          },
          completed: {
            border: "left",
            icon: "fas fa-clipboard-check",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Completat",
          },
        }[row.status] || "-",
      ];

      const x = this.PERMISIONS;
      const prepareBtn = [];

      if (x.edit === true && !this.notAllowEdit) {
        prepareBtn.push(2);
      }
      if (x.delete === true && !this.notAllowEdit) {
        prepareBtn.push(3);
      }

      preparation.push([prepareBtn]);

      return preparation;
    },

    editProduct(item) {
      if (this.notAllowEdit) {
        this.$toastr.w("Produsul nu mai poate fi modificat.");
        return;
      }
      this.$modal.show(
        DialogModal,
        {
          target: "AssignmentProductsEdit",
          title: "Completare produs",
          inputs: [
            {
              id: "assignmentProduct",
              type: "component",
              component: EditAssignmentProduct,
              componentProps: {
                assignmentDocument: this.assignmentDocument,
                assignmentProduct: item,
              },
            },
          ],
          closeBtnText: "Anulează",
          acceptFinish: (data) => {
            const assignmentProduct = data.assignmentProduct;

            if (this.assignmentDocument.numberOfReferences == 0) {
              delete assignmentProduct.need;
              delete assignmentProduct.needReferate;
            }

            for (const key in assignmentProduct) {
              if (!assignmentProduct[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }
            }
            return true;
          },
          button: {
            type: 2,
            value: "Completează",
            handler: (sendData) => {
              const assignmentProduct = sendData.assignmentProduct;
              const error = (msg) => {
                this.$toastr.e(msg || "Completarea produsului a eșuat.");
              };

              this.setSafeLoad(12000);

              ASSIGNMENT_PRODUCTS.edit(assignmentProduct.id, {
                ...assignmentProduct,
                status: "completed",
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Completarea produsului a fost efectuat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "AssignmentProductsEdit",
          adaptive: true,
          width: "700px",
          height: "610px",
        },
      );
    },

    addProduct() {
      if (this.notAllowEdit()) {
        this.$toastr.w("Nu se poate adăuga produse.");
        return;
      }
      this.$modal.show(
        DialogModal,
        {
          target: "AssignmentProductsEdit",
          title: "Completare produs",
          inputs: [
            {
              id: "assignmentProduct",
              type: "component",
              component: EditAssignmentProduct,
              componentProps: {
                assignmentDocument: this.assignmentDocument,
              },
            },
          ],
          closeBtnText: "Anulează",
          acceptFinish: (data) => {
            const assignmentProduct = data.assignmentProduct;
            for (const key in assignmentProduct) {
              if (!assignmentProduct[key]) {
                this.$toastr.w("Nu au fost completate toate secțiunile.");
                return false;
              }
            }
            return true;
          },
          button: {
            type: 2,
            value: "Salvează",
            handler: (sendData) => {
              const assignmentProduct = sendData.assignmentProduct;
              const error = (msg) => {
                this.$toastr.e(msg || "Completarea produsului a eșuat.");
              };

              this.setSafeLoad(12000);

              ASSIGNMENT_PRODUCTS.add({
                ...assignmentProduct,
                status: "completed",
                assignmentDocument: this.assignmentDocument,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Completarea produsului a fost efectuat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "AssignmentProductsEdit",
          adaptive: true,
          width: "700px",
          height: "610px",
        },
      );
    },

    deleteProduct(item) {
      if (this.notAllowEdit) {
        this.$toastr.w(
          Messages.CANNOT_DELETE_ASSIGNMENT_PRODUCT_INVALID_STATUS,
        );
        return;
      }

      this.$modal.show(
        DialogModal,
        {
          target: "DeleteAssignmentProduct",
          title: `Sunteți sigur că doriți să ștergeți produsul "${item.product?.name}"?`,
          subtitle: "Acțiunea este irevocabilă.",
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              this.setSafeLoad(12000);

              ASSIGNMENT_PRODUCTS.delete(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Produsul a fost șters cu succes.");
                    this.reload();
                    this.setLoad();
                  } else {
                    this.$toastr.e(
                      res?.response || "Ștergerea produsului a eșuat.",
                    );
                    this.setLoad();
                  }
                })
                .catch((err) => {
                  this.$toastr.e(
                    err.message || "Ștergerea produsului a eșuat.",
                  );
                  this.setLoad();
                });
            },
          },
        },
        {
          name: "DeleteAssignmentProduct",
          adaptive: true,
          width: "550px",
          height: "auto",
        },
      );
    },
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }
    this.$emit("input", this.assignmentDocument);
  },
};
</script>
<style></style>
